<div class="order-return-details mb-5">
  <div class="order-return-details-card p-5 mb-5">
    <div class="d-flex justify-content-between">
      <div class="align-self-center">
        <h3 class="mt-4 inline">Return Order Items</h3>
      </div>
      <div class="align-self-center">
        <button
          type="button"
          class="lum-button lum-button--secondary"
          mat-button
          [routerLink]="['/orders/return-orders/', parentSalesOrderId]"
        >
          <lum-ui-icon
            icon="chevron-left-circle"
            [width]="24"
            [height]="24"
            color="#5563d6"
          ></lum-ui-icon>
          Go Back To Return Orders
        </button>
      </div>
    </div>
    <mat-divider class="mb-5 mt-2"></mat-divider>
    <div class="row">
      <div class="col-md-6">
        <div class="mb-4">
          <strong>Return Order ID</strong><br />
          <p>{{ currentOrderReturn?.id }}</p>
        </div>
        <div class="mb-4">
          <strong>Order ID</strong><br />
          <p>{{ currentOrderReturn?.orderId }}</p>
        </div>
        <div class="mb-4">
          <strong>Order Date</strong><br />
          <p>{{ currentOrderReturn?.orderDate | date: 'mediumDate' }}</p>
        </div>
        <div class="mb-4">
          <strong>Created Date</strong><br />
          <p>{{ currentOrderReturn?.createDate | date: 'mediumDate' }}</p>
        </div>
      </div>
      <div class="col-md-6">
        <div class="mb-4">
          <strong>Order Status</strong><br />
          <mat-chip
            *ngIf="currentOrderReturn?.orderStatus; else noData"
            class="
              lum-chip border-transparent text-cloud-900 bg-cloud-300 hover:cloud-400 active:cloud-500 focus:cloud-400 lum-chip--small
            "
            >{{ currentOrderReturn.orderStatus }}</mat-chip
          >
        </div>
        <div class="mb-4">
          <strong>Payment Method</strong><br />
          <mat-chip
            *ngIf="currentOrderReturn?.paymentMethod; else noData"
            class="
              lum-chip border-transparent text-cloud-900 bg-cloud-300 hover:cloud-400 active:cloud-500 focus:cloud-400 lum-chip--small
            "
            >{{ currentOrderReturn.paymentMethod }}</mat-chip
          >
        </div>
        <div class="mb-4">
          <strong>Source</strong><br />
          <mat-chip
            *ngIf="currentOrderReturn?.source; else noData"
            class="
              lum-chip border-transparent text-cloud-900 bg-cloud-300 hover:cloud-400 active:cloud-500 focus:cloud-400 lum-chip--small
            "
            >{{ currentOrderReturn.source }}</mat-chip
          >
        </div>
        <div class="mb-4">
          <strong>Re-stock</strong><br />
          <ng-container
            *ngIf="currentOrderReturn?.skipInventory; else affectInventory"
          >
            <mat-chip
              class="
                lum-chip border-transparent text-cloud-900 bg-cloud-300 hover:cloud-400 active:cloud-500 focus:cloud-400 lum-chip--small
              "
              >Skip Inventory</mat-chip
            >
          </ng-container>
          <ng-template #affectInventory>
            <mat-chip
              class="
                lum-chip border-transparent text-cloud-900 bg-cloud-300 hover:cloud-400 active:cloud-500 focus:cloud-400 lum-chip--small
              "
              >Affect Inventory</mat-chip
            >
          </ng-template>
        </div>
      </div>
    </div>
  </div>
  <div class="order-return-details-card p-5 mb-5">
    <ng-container *ngIf="(loading$ | async) === false; else loader">
      <lum-order-return-item-table
        *ngIf="(currentOrderReturnItems$ | async)?.length; else noRecords"
        [orderReturnItems]="currentOrderReturnItems"
        [orderReturn]="currentOrderReturn"
        [parentSalesOrder]="currentParentSalesOrder"
        [restockingFee]="restockingFee"
        [customRefundAmount]="customRefundAmount"
      ></lum-order-return-item-table>
    </ng-container>
    <ng-template #loader> </ng-template>
    <ng-template #noData>
      <strong>N/A</strong>
    </ng-template>
    <ng-template #noRecords>
      <div class="text-center p-4">
        <h3>No records available.</h3>
      </div>
    </ng-template>
  </div>
  <div class="mb-5"></div>
</div>
